import { gsap } from "gsap";

export default function () {
    const teamTimeline = gsap.timeline()
    if (!document.querySelector('[data-block="team"]'))
        return teamTimeline

    const teamHeading = gsap.timeline({
        scrollTrigger: {
            trigger: '[data-block="team"]',
            start: 'top center',
            scrub: false,
            once: true
        }
    })

    teamHeading.from('[data-block="team-heading"] > h2', { opacity: 0, y: 40 })
        .from('[data-block="team-heading"] > span', { opacity: 0, y: -40 }, '<')

    const teamMember = gsap.timeline({
        scrollTrigger: {
            trigger: '[data-block="team-member"]',
            start: 'top center',
            scrub: false,
            once: true
        }
    })

    // TODO: refaktorovat v případě více členů, aby se triggerovalo jednotlivě a né najednou

    teamMember.from('[data-block="team-member"] > figure img', { xPercent: -100, yPercent: 100, ease: "cubic", duration: 1.6 })
        .from('[data-block="team-member"] > h3', { opacity: 0, y: 40 }, '>')
        .from('[data-block="team-member"] > p', { opacity: 0, y: 40 }, '-=.24')
        .from('[data-block="team-member"] a.Icon > svg', { opacity: 0, stagger: .2 }, '>')

    return teamTimeline
}